module.exports = __webpack_public_path__ + "media/images/lb/265-0d7c59cc19aa288f631dcf6f8eb65567.svg";